import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useId } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FieldLabel } from 'src/shared/components/form/field/label';
import RenderClubAdmin from 'src/shared/components/renderClubAdmin/renderClubAdmin';
export function ContentEditor() {
    const { setValue, watch } = useFormContext();
    const { t } = useTranslation();
    const inputId = useId();
    const handleChange = useCallback((event) => {
        setValue('content', event.target.value, { shouldDirty: true });
    }, [setValue]);
    return (_jsxs("div", { className: "mb-1", children: [_jsx(FieldLabel, { className: "mb-1", htmlFor: inputId, children: t('content.form.text') }), _jsx(RenderClubAdmin, { __name: "ContentEditor", id: inputId, placeholder: "general.editor_placeholder", upsell: false, value: watch('content'), onChange: handleChange })] }));
}
